document.addEventListener("DOMContentLoaded", function() {
  const fadeDuration = 5 * 1000; // カスタマイズされた秒数
  const images = document.querySelectorAll('.fade-image-block');
  let currentIndex = 0;

  function showNextImage() {
    images.forEach((img, index) => {
      img.style.opacity = 0;
    });
    
    setTimeout(() => {
      images[currentIndex].style.opacity = 1;
    }, 10);

    currentIndex = (currentIndex + 1) % images.length;
  }

  showNextImage();
  setInterval(showNextImage, fadeDuration);
});

